/**
 * Maestro Animal - Product Card quick add
 * Preview de precio al hover/focus sobre un tamano, anadir al carrito
 * via Ajax API al hacer click/tap, con confirmacion visual propia
 * (imagen volando al carrito + rebote del icono + toast con el nombre
 * real del producto) que NO depende de cart-notification/cart-drawer
 * nativos (esa integracion pedia secciones inexistentes y fallaba,
 * dando un falso error aunque el producto si se anadiese).
 */
(function () {
  const SELECTORS = {
    card: '[data-ma-product-card]',
    priceValue: '[data-ma-price-value]',
    priceLabel: '[data-ma-price-label]',
    price: '[data-ma-price]',
    chip: '[data-ma-size-chip]',
    image: '.ma-card__image',
  };

  function initCard(card) {
    const priceEl = card.querySelector(SELECTORS.price);
    const priceValueEl = card.querySelector(SELECTORS.priceValue);
    const priceLabelEl = card.querySelector(SELECTORS.priceLabel);
    const defaultPriceHTML = priceValueEl ? priceValueEl.textContent : '';
    const defaultLabelDisplay = priceLabelEl ? priceLabelEl.style.display : '';

    const chips = card.querySelectorAll(SELECTORS.chip);

    chips.forEach((chip) => {
      if (chip.disabled) return;

      chip.addEventListener('mouseenter', () => showPreview(chip));
      chip.addEventListener('focus', () => showPreview(chip));
      chip.addEventListener('mouseleave', () => resetPreview());
      chip.addEventListener('blur', () => resetPreview());

      chip.addEventListener('click', (e) => {
        e.preventDefault();
        addToCart(chip);
      });
    });

    function showPreview(chip) {
      if (!priceValueEl) return;
      priceValueEl.textContent = chip.dataset.variantPrice;
      if (priceLabelEl) priceLabelEl.style.display = 'none';
      priceEl.setAttribute('data-price-active', 'true');
    }

    function resetPreview() {
      if (!priceValueEl) return;
      priceValueEl.textContent = defaultPriceHTML;
      if (priceLabelEl) priceLabelEl.style.display = defaultLabelDisplay;
      priceEl.removeAttribute('data-price-active');
    }

    async function addToCart(chip) {
      if (chip.dataset.loading === 'true') return;
      chip.dataset.loading = 'true';
      const originalText = chip.textContent;
      chip.textContent = '…';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: chip.dataset.variantId, quantity: 1 }],
          }),
        });

        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.description || 'No se pudo añadir el producto');
        }

        const addResult = await response.json();
        const addedItem = (addResult.items && addResult.items[0]) || addResult;

        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await cartResponse.json();
        updateCartIconBubble(cart.item_count);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'maestro-product-card', cartData: cart });
        }

        flyToCart(card);
        pulseChip(chip);
        showToast(card, addedItem);
        chip.textContent = '✓';
        setTimeout(() => {
          chip.textContent = originalText;
        }, 900);
      } catch (error) {
        console.error('[Maestro Animal] Error al añadir al carrito:', error);
        chip.textContent = originalText;
        chip.classList.add('ma-chip-error');
        setTimeout(() => chip.classList.remove('ma-chip-error'), 900);
      } finally {
        chip.dataset.loading = 'false';
      }
    }

    function pulseChip(chip) {
      chip.classList.remove('ma-chip-success');
      void chip.offsetWidth;
      chip.classList.add('ma-chip-success');
      chip.addEventListener(
        'animationend',
        () => chip.classList.remove('ma-chip-success'),
        { once: true }
      );
    }
  }

  function updateCartIconBubble(itemCount) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    const countSpan = cartIcon.querySelector('.cart-count-bubble span[aria-hidden]');
    if (countSpan) countSpan.textContent = itemCount < 100 ? itemCount : '';

    cartIcon.classList.remove('ma-cart-bump');
    void cartIcon.offsetWidth;
    cartIcon.classList.add('ma-cart-bump');
    cartIcon.addEventListener('animationend', () => cartIcon.classList.remove('ma-cart-bump'), { once: true });
  }

  function flyToCart(card) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    const image = card.querySelector(SELECTORS.image);
    if (!cartIcon || !image || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const imgRect = image.getBoundingClientRect();
    const cartRect = cartIcon.getBoundingClientRect();

    const flyer = image.cloneNode(true);
    flyer.className = 'ma-fly-clone';
    flyer.style.position = 'fixed';
    flyer.style.left = `${imgRect.left}px`;
    flyer.style.top = `${imgRect.top}px`;
    flyer.style.width = `${imgRect.width}px`;
    flyer.style.height = `${imgRect.height}px`;
    flyer.style.margin = '0';
    document.body.appendChild(flyer);

    const deltaX = cartRect.left + cartRect.width / 2 - (imgRect.left + imgRect.width / 2);
    const deltaY = cartRect.top + cartRect.height / 2 - (imgRect.top + imgRect.height / 2);

    requestAnimationFrame(() => {
      flyer.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.12)`;
      flyer.style.opacity = '0.25';
    });

    setTimeout(() => flyer.remove(), 700);
  }

  function showToast(card, item) {
    let toast = card.querySelector('.ma-add-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ma-add-toast';
      card.appendChild(toast);
    }
    const title = (item && (item.product_title || item.title)) || 'Producto';
    toast.textContent = `✓ Añadido: ${title}`;
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(() => toast.classList.remove('is-visible'), 1800);
  }

  document.querySelectorAll(SELECTORS.card).forEach(initCard);
})();
